import React, { useState, useEffect } from 'react';
import Preloader from '../Preloader';

const PageWrapper = ({ children }) => {
  const [isPageLoading, setIsPageLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPageLoading(false);
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  if (isPageLoading) {
    return <Preloader />;
  }

  return <>{children}</>;
};

export default PageWrapper;